import { render, staticRenderFns } from "./JP.vue?vue&type=template&id=6c15560f&scoped=true&"
import script from "./JP.vue?vue&type=script&lang=js&"
export * from "./JP.vue?vue&type=script&lang=js&"
import style0 from "./JP.vue?vue&type=style&index=0&id=6c15560f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c15560f",
  null
  
)

export default component.exports